<template>
  <div>
    <b-form-group
      label="Bitiş Tarihi"
      label-for="edate"
    >
      <validation-provider
        #default="{ errors }"
        name="Bitiş Tarihi"
        rules="required"
      >
        <b-form-datepicker
          id="edate"
          v-model="dataItem.edate"
          v-bind="{labelNoDateSelected: 'Bitiş Tarihi',labelHelp: 'Ok tuşlarıyla takvimde gezinin'}"
          locale="tr"
          start-weekday="1"
        />
        <small class="text-danger">{{ errors[0] }}</small>
      </validation-provider>
    </b-form-group>
  </div>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import { BFormGroup, BFormDatepicker } from 'bootstrap-vue'
// eslint-disable-next-line no-unused-vars
import { required } from '@validations'

export default {
  name: 'PurchaseOfferEdate',
  components: {
    BFormGroup,
    BFormDatepicker,
    ValidationProvider,
  },
  data() {
    return {
      locale: 'tr',
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['purchaseOffers/dataItem']
    },
  },
  created() {
    localize(this.locale)
  },
}
</script>
<style scoped></style>
